import GenericStore from '../classes/generic-store';
import { getOpportunityCandidates } from '../api/opportunity-legacy-api';

class OpportunityCandidatesStoreClass extends GenericStore {
  load(opportunityId) {
    return this.setState(getOpportunityCandidates(opportunityId));
  }
}

export const OpportunityCandidatesStore = new OpportunityCandidatesStoreClass();
